import React, { useRef } from 'react';
import styled from 'styled-components';

import { formatPrice, getItemPrice } from '../../utils';

const StyledOrderListItem = styled.li`
  display: flex;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
  
  font-size: 20px;
  line-height: 24px; 
 
  border-top: 1px solid #e7e7e7;
  
  cursor: pointer;
  
  &:last-child {
    border-bottom: 1px solid #e7e7e7;
  }
`;

const Wrapper = styled.p`
  display: flex;
  flex-direction: column;
  
  margin: 0;
  
`;

const Number = styled.span`
  font-size: 14px;
  line-height: 16px; 
  opacity: 0.5;
`;

const Toppings = styled.span`
  position: relative;

  display: inline-block;
  max-width: 160px;
  margin-top: 30px;
  padding: 10px;
  padding-right: 15px;

  font-size: 16px;
  line-height: 18px; 
  color: #ffffff;
  
  background-color: #fa9e39;
  border-radius: 6px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  
  &::before {
    content: "Добавлено:";
    
    position: absolute;
    top: -20px;
    left: 0;
    
    line-height: 16px;
    color: #333333;
    opacity: 0.8;
  }
`;

const Price = styled.b`
  margin-left: auto;
  margin-right: 5px;
  
  font-size: 20px;
  line-height: 40px; 
  font-weight: 700;
`;

const RemoveButton = styled.button`
  width: 40px;
  height: 40px;
  padding: 5px;
  
  background-color: transparent;
  background-image: url("data:image/svg+xml,%3Csvg height='512pt' viewBox='-47 0 512 512' width='512pt' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m416.875 114.441406-11.304688-33.886718c-4.304687-12.90625-16.339843-21.578126-29.941406-21.578126h-95.011718v-30.933593c0-15.460938-12.570313-28.042969-28.027344-28.042969h-87.007813c-15.453125 0-28.027343 12.582031-28.027343 28.042969v30.933593h-95.007813c-13.605469 0-25.640625 8.671876-29.945313 21.578126l-11.304687 33.886718c-2.574219 7.714844-1.2695312 16.257813 3.484375 22.855469 4.753906 6.597656 12.445312 10.539063 20.578125 10.539063h11.816406l26.007813 321.605468c1.933594 23.863282 22.183594 42.558594 46.109375 42.558594h204.863281c23.921875 0 44.175781-18.695312 46.105469-42.5625l26.007812-321.601562h6.542969c8.132812 0 15.824219-3.941407 20.578125-10.535157 4.753906-6.597656 6.058594-15.144531 3.484375-22.859375zm-249.320312-84.441406h83.0625v28.976562h-83.0625zm162.804687 437.019531c-.679687 8.402344-7.796875 14.980469-16.203125 14.980469h-204.863281c-8.40625 0-15.523438-6.578125-16.203125-14.980469l-25.816406-319.183593h288.898437zm-298.566406-349.183593 9.269531-27.789063c.210938-.640625.808594-1.070313 1.484375-1.070313h333.082031c.675782 0 1.269532.429688 1.484375 1.070313l9.269531 27.789063zm0 0'/%3E%3Cpath d='m282.515625 465.957031c.265625.015625.527344.019531.792969.019531 7.925781 0 14.550781-6.210937 14.964844-14.21875l14.085937-270.398437c.429687-8.273437-5.929687-15.332031-14.199219-15.761719-8.292968-.441406-15.328125 5.925782-15.761718 14.199219l-14.082032 270.398437c-.429687 8.273438 5.925782 15.332032 14.199219 15.761719zm0 0'/%3E%3Cpath d='m120.566406 451.792969c.4375 7.996093 7.054688 14.183593 14.964844 14.183593.273438 0 .554688-.007812.832031-.023437 8.269531-.449219 14.609375-7.519531 14.160157-15.792969l-14.753907-270.398437c-.449219-8.273438-7.519531-14.613281-15.792969-14.160157-8.269531.449219-14.609374 7.519532-14.160156 15.792969zm0 0'/%3E%3Cpath d='m209.253906 465.976562c8.285156 0 15-6.714843 15-15v-270.398437c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v270.398437c0 8.285157 6.714844 15 15 15zm0 0'/%3E%3C/svg%3E");  background-repeat: no-repeat;
  background-size: 25px 25px;
  background-position: center;
  border: none;
  outline: none;
  
  transition: 0.2s;
  
  cursor: pointer;
  
  &:hover,
  &:focus {
    background-image: url("data:image/svg+xml,%3Csvg height='512pt' viewBox='-57 0 512 512' width='512pt' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m156.371094 30.90625h85.570312v14.398438h30.902344v-16.414063c.003906-15.929687-12.949219-28.890625-28.871094-28.890625h-89.632812c-15.921875 0-28.875 12.960938-28.875 28.890625v16.414063h30.90625zm0 0'/%3E%3Cpath d='m344.210938 167.75h-290.109376c-7.949218 0-14.207031 6.78125-13.566406 14.707031l24.253906 299.90625c1.351563 16.742188 15.316407 29.636719 32.09375 29.636719h204.542969c16.777344 0 30.742188-12.894531 32.09375-29.640625l24.253907-299.902344c.644531-7.925781-5.613282-14.707031-13.5625-14.707031zm-219.863282 312.261719c-.324218.019531-.648437.03125-.96875.03125-8.101562 0-14.902344-6.308594-15.40625-14.503907l-15.199218-246.207031c-.523438-8.519531 5.957031-15.851562 14.472656-16.375 8.488281-.515625 15.851562 5.949219 16.375 14.472657l15.195312 246.207031c.527344 8.519531-5.953125 15.847656-14.46875 16.375zm90.433594-15.421875c0 8.53125-6.917969 15.449218-15.453125 15.449218s-15.453125-6.917968-15.453125-15.449218v-246.210938c0-8.535156 6.917969-15.453125 15.453125-15.453125 8.53125 0 15.453125 6.917969 15.453125 15.453125zm90.757812-245.300782-14.511718 246.207032c-.480469 8.210937-7.292969 14.542968-15.410156 14.542968-.304688 0-.613282-.007812-.921876-.023437-8.519531-.503906-15.019531-7.816406-14.515624-16.335937l14.507812-246.210938c.5-8.519531 7.789062-15.019531 16.332031-14.515625 8.519531.5 15.019531 7.816406 14.519531 16.335937zm0 0'/%3E%3Cpath d='m397.648438 120.0625-10.148438-30.421875c-2.675781-8.019531-10.183594-13.429687-18.640625-13.429687h-339.410156c-8.453125 0-15.964844 5.410156-18.636719 13.429687l-10.148438 30.421875c-1.957031 5.867188.589844 11.851562 5.34375 14.835938 1.9375 1.214843 4.230469 1.945312 6.75 1.945312h372.796876c2.519531 0 4.816406-.730469 6.75-1.949219 4.753906-2.984375 7.300781-8.96875 5.34375-14.832031zm0 0'/%3E%3C/svg%3E");
  }
`;

const OrderListItem = ({ order, removeItem, index, setSelectedItem }) => {
  const toppings = order.selectedToppings &&
    order.selectedToppings
      .filter(topping => topping.selected)
      .map(topping => topping.name)
      .join(', ');

  const refRemoveButton = useRef(null);

  const editItem = evt => {
    if (evt.target !== refRemoveButton.current) {
      setSelectedItem({ ...order, index });
    }
  };

  return (
    <StyledOrderListItem onClick={editItem}>
      <Wrapper>
        {order.name} {order.choices && `(${order.choice})`}
        <Number>{order.quantity} шт</Number>
        {toppings && <Toppings>{toppings}</Toppings>}
      </Wrapper>
      <Price>
        {formatPrice(getItemPrice(order))}
      </Price>
      <RemoveButton ref={refRemoveButton} onClick={() => removeItem(index)} />
    </StyledOrderListItem>
  );
};

export default OrderListItem;
